<template>
  <div class="container lms-wrapper no-right-sidebar">
    <div class="lms-sidebar">
      <div class="lms-sidebar-body">
        <vue-custom-scrollbar :style="`height: ${getScrollHeight()}`">
          <div :class="`card ${$store.state.app.isMobile ? 'bd-0' : ''}`">
            <div class="card-body">
              <student-nav
                @route-changed="toggleNavbar(false)"
                :obj.sync="statObj"
              >
                <lib-search
                  v-if="searchRdy && $route.params.m == 1"
                  :searches="searches"
                  :tasks="tasks"
                  :allCount="allCount"
                  class="mg-t-40"
                  @on-search="search($event)"
                  @on-reset="init(true)"
                  :key="searchKey"
                />
              </student-nav>
            </div>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div>
    <div class="lms-content">
      <div class="lms-content-body">
        <template v-if="$route.params.m == 0">
          <section v-if="$route.params.id == 0">
            <ul class="nav nav-line nav-line-profile mg-b-30">
              <li class="nav-item">
                <router-link
                  :to="{
                    name: 'lmsLibrary',
                    params: { id: 0, cid: 0, title: 'Номын сан' }
                  }"
                  class="nav-link d-flex align-items-center"
                  :class="{ active: $route.params.cid == 0 }"
                  >Бүх ном
                  <span class="badge">{{ allCount }}</span></router-link
                >
              </li>
              <li class="nav-item" v-for="(c, i) in categories" :key="i">
                <router-link
                  :to="{
                    name: 'lmsLibrary',
                    params: { id: 0, cid: c.id, title: c.s1 }
                  }"
                  class="nav-link d-flex align-items-center"
                  :class="{ active: $route.params.cid == c.id }"
                  >{{ c.s1 }}</router-link
                >
              </li>
            </ul>
            <vue-custom-scrollbar :style="`height: ${getScrollHeight()}`">
              <div class="row row-xs mg-b-25 books">
                <div
                  @click="readEbook(t)"
                  class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-3 pd-x-15-f"
                  v-for="(t, i) in tasks"
                  :key="i"
                  role="button"
                >
                  <div class="card">
                    <div
                      v-if="isNewBook(t)"
                      class="
                        marker marker-ribbon marker-success
                        pos-absolute
                        t-10
                        l-0
                      "
                    >
                      Шинэ
                    </div>
                    <button
                      v-if="t.i1 > 0"
                      class="
                        btn btn-xs
                        pd-x-15
                        btn-uppercase
                        rounded-pill
                        pos-absolute
                        r-10
                        t-10
                        btn-white
                      "
                    >
                      {{ displayMinute(t.i1) }}
                    </button>
                    <div class="bd-b">
                      <img
                        :src="`${t.defaultAttachmentUrl}?w=210&h=297&mode=pad`"
                        class="card-img-top pd-10"
                        alt=""
                        style="max-height: 250px; min-height: 250px"
                      />
                    </div>
                    <div class="card-body tx-13 pd-y-10 pd-x-5 bg-light">
                      <div>
                        <h6 class="text-center ht-40 mg-b-0-f tx-14">
                          {{ t.task }}
                        </h6>

                        <div class="d-flex mg-t-20 text-muted tx-12">
                          <p
                            class="mg-b-0 text-truncate pd-r-20"
                            :title="t.st1"
                          >
                            {{ t.st1 }}
                          </p>
                          <p class="mg-l-auto mg-b-0">{{ t.st2 }}он</p>
                        </div>
                        <!-- <router-link :to="{name: 'lmsLibrary', params:{ id: t.secondAttachmentId, cid: t.id, title: t.task } }" class="btn btn-block btn-white">Үзэх</router-link> -->
                        <!-- <a @click="readEbook(t)" class="btn btn-block btn-white">Үзэх</a> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </vue-custom-scrollbar>
          </section>
          <section v-if="$route.params.id > 0">
            <div class="mg-b-20 pd-b-10 bd-b d-flex align-items-center">
              <router-link
                :to="{
                  name: 'lmsLibrary',
                  params: { id: 0, cid: 0, title: 'Номын сан' }
                }"
              >
                <feather type="chevron-left" class="mg-r-10"></feather>
              </router-link>
              <h5 class="tx-uppercase tx-semibold mg-b-0">
                {{ $route.params.title }}
              </h5>

              <attach-rating
                v-if="fileInf.ready"
                :fileInf.sync="fileInf"
                class="mg-l-auto"
                disabled
                @on-rate="onRated"
                :allowHalf="false"
              />
              <button
                v-if="
                  bkDtl.rdy &&
                    bkDtl.obj.isRepeat &&
                    bkDtl.obj.secondAttachmentUrl != ''
                "
                @click="downloadBook()"
                class="mg-l-10 btn btn-outline-success btn-xs"
              >
                <feather type="download" class="mg-r-5"></feather>
                татах
              </button>
            </div>

            <file-preview
              v-if="bkDtl.rdy"
              :id.sync="bkDtl.obj.defaultAttachmentId"
              @on-file-loaded="onFileLoaded"
              :force="true"
              class="d-none"
            />

            <file-preview
              :id.sync="$route.params.id"
              :params="$route.params"
              :force="true"
              :minusHeight="$store.state.app.isMobile ? 140 : 160"
            />
          </section>
        </template>
        <div class="card" v-else-if="$route.params.m == 1">
          <div class="card-header d-flex justify-content-between">
            <h6 class="lh-5 mg-b-0">Ном захиалга</h6>
            <b-pagination
              v-if="allCount > 0"
              class="mg-r-20"
              size="sm"
              align="center"
              v-model="pager.page"
              :total-rows="allCount"
              :per-page="pager.size"
              @change="pageChanged"
              style="margin-bottom: 0"
            ></b-pagination>
          </div>
          <div class="card-body pd-x-0 pd-y-10">
            <vue-custom-scrollbar :style="`height: ${getScrollHeight(195)}`">
              <lib-books
                :tasks="tasks"
                :nowDate="nowDate"
                @on-order="orderBook"
              />
            </vue-custom-scrollbar>
          </div>
        </div>
        <div class="card" v-else-if="$route.params.m == 2">
          <div class="card-header d-flex justify-content-between">
            <h6 class="lh-5 mg-b-0">Миний номууд</h6>
            <b-pagination
              v-if="allCount > 0"
              class="mg-r-20"
              size="sm"
              align="center"
              v-model="pager.page"
              :total-rows="allCount"
              :per-page="pager.size"
              @change="pageChanged"
              style="margin-bottom: 0"
            ></b-pagination>
          </div>
          <div class="card-body pd-x-0 pd-y-10">
            <vue-custom-scrollbar :style="`height: ${getScrollHeight(195)}`">
              <lib-items
                :tasks="tasks"
                @on-cancel-order="cancelOrderConfirm"
                @on-item-modal="onItemModal"
              />
            </vue-custom-scrollbar>
          </div>
        </div>
        <div class="card" v-else-if="$route.params.m == 3">
          <div class="card-header d-flex justify-content-between">
            <h6 class="lh-5 mg-b-0">Захиалгын түүх</h6>
            <b-pagination
              v-if="allCount > 0"
              class="mg-r-20"
              size="sm"
              align="center"
              v-model="pager.page"
              :total-rows="allCount"
              :per-page="pager.size"
              @change="pageChanged"
              style="margin-bottom: 0"
            ></b-pagination>
          </div>
          <div class="card-body pd-x-0 pd-y-10">
            <div
              class="
                ht-100
                d-flex
                align-items-center
                justify-content-between
                pd-x-100
              "
            >
              <div class="media">
                <div
                  class="
                    wd-40 wd-md-50
                    ht-40 ht-md-50
                    bg-primary
                    tx-white
                    mg-r-10 mg-md-r-10
                    d-flex
                    align-items-center
                    justify-content-center
                    rounded
                    op-6
                  "
                >
                  <feather type="menu"></feather>
                </div>
                <div class="media-body">
                  <h6
                    class="
                      tx-sans
                      tx-uppercase
                      tx-10
                      tx-spacing-1
                      tx-color-03
                      tx-semibold
                      tx-nowrap
                      mg-b-5 mg-md-b-8
                    "
                  >
                    Нийт захиалга
                  </h6>
                  <h4 class="tx-20 tx-sm-18 tx-md-24 tx-normal tx-rubik mg-b-0">
                    {{ statObj.data.order.allCount }}
                  </h4>
                </div>
              </div>
              <div class="media">
                <div
                  class="
                    wd-40 wd-md-50
                    ht-40 ht-md-50
                    bg-success
                    tx-white
                    mg-r-10 mg-md-r-10
                    d-flex
                    align-items-center
                    justify-content-center
                    rounded
                    op-6
                  "
                >
                  <feather type="menu"></feather>
                </div>
                <div class="media-body">
                  <h6
                    class="
                      tx-sans
                      tx-uppercase
                      tx-10
                      tx-spacing-1
                      tx-color-03
                      tx-semibold
                      tx-nowrap
                      mg-b-5 mg-md-b-8
                    "
                  >
                    Баталгаажсан захиалга
                  </h6>
                  <h4 class="tx-20 tx-sm-18 tx-md-24 tx-normal tx-rubik mg-b-0">
                    {{ statObj.data.order.acceptedCount }}
                  </h4>
                </div>
              </div>
              <div class="media">
                <div
                  class="
                    wd-40 wd-md-50
                    ht-40 ht-md-50
                    bg-danger
                    tx-white
                    mg-r-10 mg-md-r-10
                    d-flex
                    align-items-center
                    justify-content-center
                    rounded
                    op-6
                  "
                >
                  <feather type="menu"></feather>
                </div>
                <div class="media-body">
                  <h6
                    class="
                      tx-sans
                      tx-uppercase
                      tx-10
                      tx-spacing-1
                      tx-color-03
                      tx-semibold
                      tx-nowrap
                      mg-b-5 mg-md-b-8
                    "
                  >
                    Буцаан өгсөн
                  </h6>
                  <h4 class="tx-20 tx-sm-18 tx-md-24 tx-normal tx-rubik mg-b-0">
                    {{ statObj.data.order.returnedCount }}
                  </h4>
                </div>
              </div>
              <div class="media">
                <div
                  class="
                    wd-40 wd-md-50
                    ht-40 ht-md-50
                    bg-warning
                    tx-white
                    mg-r-10 mg-md-r-10
                    d-flex
                    align-items-center
                    justify-content-center
                    rounded
                    op-6
                  "
                >
                  <feather type="menu"></feather>
                </div>
                <div class="media-body">
                  <h6
                    class="
                      tx-sans
                      tx-uppercase
                      tx-10
                      tx-spacing-1
                      tx-color-03
                      tx-semibold
                      tx-nowrap
                      mg-b-5 mg-md-b-8
                    "
                  >
                    Надад байгаа
                  </h6>
                  <h4 class="tx-20 tx-sm-18 tx-md-24 tx-normal tx-rubik mg-b-0">
                    {{ statObj.data.order.inProgressCount }}
                  </h4>
                </div>
              </div>
            </div>
            <vue-custom-scrollbar :style="`height: ${getScrollHeight(295)}`">
              <lib-orders
                :tasks="tasks"
                @on-cancel-order="cancelOrderConfirm"
              />
            </vue-custom-scrollbar>
          </div>
        </div>
        <div class="card" v-else-if="$route.params.m == 4">
          <div class="card-header d-flex justify-content-between">
            <h6 class="lh-5 mg-b-0">Номын сангийн хяналт</h6>
            <b-pagination
              v-if="allCount > 0"
              class="mg-r-20"
              size="sm"
              align="center"
              v-model="pager.page"
              :total-rows="allCount"
              :per-page="pager.size"
              @change="pageChanged"
              style="margin-bottom: 0"
            ></b-pagination>
          </div>
          <div class="card-body pd-x-0 pd-y-10">
            <div
              class="
                ht-100
                d-flex
                align-items-center
                justify-content-between
                pd-x-100
              "
            >
              <div
                @click="filterListByStts(s)"
                v-for="(s, i) in stts"
                :key="i"
                class="media"
                role="button"
              >
                <div
                  :class="
                    `${s.color} wd-40 wd-md-50 ht-40 ht-md-50 tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-6`
                  "
                >
                  <feather type="menu"></feather>
                </div>
                <div class="media-body">
                  <h6
                    class="
                      tx-sans
                      tx-uppercase
                      tx-10
                      tx-spacing-1
                      tx-color-03
                      tx-semibold
                      tx-nowrap
                      mg-b-5 mg-md-b-8
                    "
                  >
                    {{ s.title }}
                  </h6>
                  <h4 class="tx-20 tx-sm-18 tx-md-24 tx-normal tx-rubik mg-b-0">
                    {{ s.val }}
                  </h4>
                </div>
              </div>
            </div>
            <vue-custom-scrollbar
              :style="`height: ${getScrollHeight(295)}`"
              class="pd-x-10"
            >
              <lib-activities
                :tasks="tasks"
                @on-decline="activitiesDeclinePrompt"
                @on-accept="acceptOrder"
                @on-giveback="giveBackOrder"
              />
            </vue-custom-scrollbar>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="order.mdl" centered size="lg" scrollable>
      <template #modal-header="{}">
        <div class="">
          <a
            @click="order.mdl = false"
            role="button"
            class="close pos-absolute t-15 r-15"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </a>
          <div class="media align-items-center">
            <span class="tx-color-03 d-none d-sm-block">
              <feather
                v-if="$route.params.m == 0"
                type="book-open"
                class="wd-40-f ht-40-f"
              ></feather>
              <feather
                v-else
                type="shopping-cart"
                class="wd-40-f ht-40-f"
              ></feather>
            </span>
            <div v-if="$route.params.m == 4" class="media-body mg-sm-l-20">
              <h4 class="tx-18 tx-sm-20 mg-b-2">Захиалга баталгаажуулах</h4>
              <p class="tx-13 tx-color-03 mg-b-0">тайлбар</p>
            </div>
            <div v-else-if="$route.params.m == 0" class="media-body mg-sm-l-20">
              <h4 class="tx-18 tx-sm-20 mg-b-2">Цахим ном</h4>
              <p class="tx-13 tx-color-03 mg-b-0"></p>
            </div>
            <div v-else-if="$route.params.m == 1" class="media-body mg-sm-l-20">
              <h4 class="tx-18 tx-sm-20 mg-b-2">Ном захиaлах</h4>
              <p class="tx-13 tx-color-03 mg-b-0">
                мэдээлэлтэй танилцаад захиалах дарна уу
              </p>
            </div>
            <div v-else-if="$route.params.m == 2" class="media-body mg-sm-l-20">
              <h4 class="tx-18 tx-sm-20 mg-b-2">Тэмдэглэл, үнэлгээ</h4>
              <p class="tx-13 tx-color-03 mg-b-0">
                та уншиж буй номдоо үнэлгээ өгөх, тэмдэглэл бичих боломжтой
              </p>
            </div>
          </div>
        </div>
      </template>
      <div class="modal-body" v-if="$route.params.m == 4">
        <div class="d-flex align-items-center">
          <div class="mg-r-5">Хугацаа:</div>
          <DatePicker
            size="mini"
            v-model="order.task.d3"
            placeholder="Огноо сонгоно уу"
            type="date"
            style="width: 100%"
            :format="'yyyy-MM-dd'"
            :value-format="'yyyy-MM-dd'"
          ></DatePicker>
        </div>
      </div>
      <div class="modal-body pd-0-f" v-else-if="$route.params.m == 0">
        <div
          v-if="order.info == null || order.info == ''"
          class="mg-b-20 bd-l bd-5 pd-l-10"
        >
          Тайлбар оруулаагүй байна
        </div>
        <div v-else v-html="order.info" class="mg-b-20 bd-l bd-5 pd-l-10"></div>
        <div v-if="order.task.budget != null">
          <h3 class="tx-rubik tx-normal mg-b-30 mg-t-auto">
            Үнэ: {{ order.task.budget }}₮
          </h3>
        </div>
      </div>
      <div class="modal-body pd-0-f" v-else-if="$route.params.m == 1">
        <div
          v-if="order.info != ''"
          v-html="order.info"
          class="mg-b-20 bd-l bd-5 pd-l-10"
        ></div>
        Хүсэлт
        <div class="el-textarea">
          <textarea
            v-model="order.task.task"
            class="el-textarea__inner"
            rows="4"
            type="text"
          ></textarea>
        </div>

        <div
          v-if="order.tip != ''"
          class="alert alert-warning mg-t-20"
          role="alert"
        >
          <h6 class="alert-heading">Санамж!</h6>
          <p class="mg-b-0-f">{{ order.tip }}</p>
        </div>

        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input"
            id="customCheck1"
            v-model="order.confirm"
          />
          <label class="custom-control-label" for="customCheck1"
            >Зөвшөөрч байна</label
          >
        </div>

        <div
          ref="executionListOuter"
          id="executions-outer"
          class="pd-0-f overflow-auto"
          :style="`height: ${scrHeight.execution}px`"
        >
          <label
            class="
              d-block
              tx-medium tx-12 tx-uppercase tx-sans tx-spacing-1 tx-color-02
              mg-t-25 mg-b-0
              pd-b-5
              bd-b
            "
            >Уншигчдын сэтгэгдэл</label
          >
          <execution-list
            ref="executionList"
            class="pd-0-f"
            :taskId="order.task.organizationTaskId"
            @on-reach-bottom="onReachBottom"
            @on-attach="showFile"
          ></execution-list>
        </div>
      </div>
      <div class="modal-body pd-0-f" v-else-if="$route.params.m == 2">
        <div
          ref="executionListOuter"
          id="executions-outer"
          class="pd-0-f overflow-auto"
          :style="`height: ${scrHeight.execution}px`"
        >
          <execution-list
            ref="executionList"
            class="pd-0-f"
            :taskId="order.itemId"
            @on-reach-bottom="onReachBottom"
            @on-attach="showFile"
          ></execution-list>
        </div>
      </div>

      <template #modal-footer>
        <div v-if="$route.params.m == 2" class="wd-100p">
          <execution-reply
            ref="executionReply"
            @on-height="scrHeight.executionReply = $event"
            :taskId="order.itemId"
            @on-posted="executionInit"
            class="pd-0-f mg-0-f"
          ></execution-reply>
        </div>
        <div class="d-flex align-items-center wd-100p">
          <div class="mg-r-auto">
            <attach-rating
              v-if="fileInf.ready"
              :fileInf.sync="fileInf"
              class="mg-l-auto"
              :disabled="$route.params.m == 2 ? false : true"
              @on-rate="onRated"
            />
            <file-preview
              v-if="order.coverId != null && order.coverId > 0"
              :id.sync="order.coverId"
              @on-file-loaded="onFileLoaded"
              :force="true"
              class="d-none"
            />
          </div>
          <template v-if="$route.params.m == 0">
            <template v-if="order.task.budget > 0 && order.task.im == null">
              <button class="btn btn-primary" @click="purchaseBook()">
                <feather type="shopping-cart" class="mg-r-5" />Худалдаж авах
              </button>
            </template>
            <template v-else>
              <button
                @click="
                  order.mdl = false;
                  $router.push(
                    `/lms/library/${order.attachId}/${order.task.id}/${order.task.task}/0`
                  );
                "
                v-if="order.attachId > 0"
                type="button"
                class="btn btn-white"
                data-dismiss="modal"
              >
                Унших
              </button>
              <div v-else class="alert alert-warning">
                Цахимаар унших боломжгүй
              </div>
            </template>
          </template>
          <button
            @click="order.mdl = false"
            v-else
            type="button"
            class="btn btn-white"
            data-dismiss="modal"
          >
            {{ $route.params.m == 2 ? "Хаах" : "Болих" }}
          </button>

          <button v-if="order.loading" type="button" class="btn btn-light">
            Түр хүлээнэ үү
          </button>
          <button
            v-else-if="$route.params.m == 4"
            @click="acceptOrderPost"
            type="button"
            class="btn btn-success"
          >
            Баталгаажуулах
          </button>
          <button
            v-else-if="$route.params.m == 1"
            @click="orderBookPost"
            type="button"
            class="btn btn-primary"
          >
            Захиалах
          </button>
        </div>
      </template>
    </b-modal>

    <b-overlay :show="overlayObj.busy" no-wrap>
      <template #overlay>
        <div
          v-if="overlayObj.processing"
          class="text-center p-4 bg-secondary text-light rounded"
        >
          <b-icon icon="info" font-scale="4"></b-icon>
          <div class="mb-3">Түр хүлээнэ үү...</div>
          <b-progress
            min="1"
            max="20"
            :value="18"
            variant="warning"
            height="5px"
            class="mx-n4 rounded-0"
          ></b-progress>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        >
          <p><strong id="form-confirm-label">Итгэлтэй байна уу?</strong></p>
          <div class="d-flex">
            <b-button
              variant="outline-danger"
              class="mr-3"
              @click="overlayObj.busy = false"
            >
              Үгүй
            </b-button>
            <b-button variant="outline-success" @click="overlayPost()"
              >Тийм</b-button
            >
          </div>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";
import { request } from "@/api/all";

import { hasOneOf } from "@/libs/tools";

import "element-ui/lib/theme-chalk/index.css";
import { DatePicker, Notification } from "element-ui";
import { flushToDom } from "@fullcalendar/vue";
const moment = require("moment");

export default {
  components: {
    vueCustomScrollbar,
    DatePicker,
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    libSearch: () => ({
      component: import(
        "@/views/modules/lms/student/pages/library/components/search.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    libBooks: () => ({
      component: import(
        "@/views/modules/lms/student/pages/library/components/books.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    libOrders: () => ({
      component: import(
        "@/views/modules/lms/student/pages/library/components/orders.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    libActivities: () => ({
      component: import(
        "@/views/modules/lms/student/pages/library/components/activities.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    libItems: () => ({
      component: import(
        "@/views/modules/lms/student/pages/library/components/items.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    filePreview: () => ({
      component: import("@/components/modules/media/previewPage.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    attachRating: () => ({
      component: import("@/components/modules/media/rate.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),

    executionList: () => ({
      component: import("@/components/task/components/executions/list.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    executionReply: () => ({
      component: import("@/components/task/components/executions/reply.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data() {
    return {
      bkDtl: {
        obj: {},
        rdy: false
      },
      fileInf: {
        ready: false,
        obj: {}
      },
      statObj: {
        data: {},
        rdy: false
      },
      nowDate: null,
      tasks: [],
      allCount: 0,
      categories: [],
      searches: [],
      searchRdy: false,
      searchKey: 0,
      order: {
        task: {},
        obj: {},
        info: "",
        coverId: null,
        attachId: null,
        tip: "",
        confirm: false,
        mdl: false,
        itemId: null
      },
      pager: {
        page: 1,
        size: 10
      },
      filterModel: {
        task: "",
        systemFlag: null
      },

      overlayObj: {
        processing: false,
        busy: false,
        processingId: 0
      },

      stts: [],
      scrHeight: {
        execution: 300,
        executionReply: 600
      },
      fileDialog: {
        show: false,
        id: 0
      }
    };
  },
  mounted() {
    this.toggleBodyClass("addClass", "app-lms");
    require("@/assets/css/dynamic.lms.css");
    this.init();
    this.build();
    this.initStat();
  },
  destroyed() {
    this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    getScrollHeight(mv) {
      let mh = 120;
      if (screen.width <= 1024) {
        mh = 85;
      }

      if (mv != undefined) {
        mh = mv;
      }

      return `calc(${window.innerHeight}px - ${mh}px) !important;`;
    },
    initStat() {
      request({
        api: { method: "GET", url: "library/MyDashboard" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.statObj.data = res.data.stat;
          this.statObj.rdy = true;
        }
      });
    },
    initLibrarianDashboard() {
      request({
        api: { method: "GET", url: "Library/LibrarianDashboard" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.stts = [];
          this.stts.push({
            id: null,
            title: "Нийт захиалга",
            icon: "",
            val: res.data.stat.order.allCount,
            color: "bg-primary",
            order: 1
          });
          this.stts.push({
            id: -1,
            title: "Цуцалсан",
            icon: "",
            val: res.data.stat.order.declinedCount,
            color: "bg-secondary",
            order: 2
          });
          this.stts.push({
            id: 2,
            title: "Буцаан авсан",
            icon: "",
            val: res.data.stat.order.returnedCount,
            color: "bg-success",
            order: 2
          });
          this.stts.push({
            id: 0,
            title: "Шинэ захиалгууд",
            icon: "",
            val: res.data.stat.order.inProgressCount,
            color: "bg-warning",
            order: 2
          });
          this.stts.push({
            id: 1,
            title: "Баталгаажсан",
            icon: "",
            val: res.data.stat.order.acceptedCount,
            color: "bg-info",
            order: 2
          });
          this.stts.push({
            id: 11,
            title: "Хугацаа хэтэрсэн",
            icon: "",
            val: res.data.stat.order.overdueCount,
            color: "bg-danger",
            order: 2
          });
          //console.log(res.data.stat);
        }
      });
    },
    build() {
      if (this.$route.params.m == 0) {
        this.getCategories();
      } else if (this.$route.params.m == 1) {
        this.initSearches();
      } else if (this.$route.params.m == 4) {
        this.initLibrarianDashboard();
      }
    },
    filterListByStts(e) {
      this.tasks = [];
      //console.log(e);
      if (e.id == 11) {
        this.filterModel = Object.assign(this.filterModel, {
          i1: 1,
          d3End: new Date()
        });
      } else {
        this.filterModel = Object.assign(this.filterModel, {
          i1: e.id,
          d3End: null
        });
      }
      //console.log(this.filterModel);
      this.init();
    },
    search(e) {
      this.navbarMode = 1;
      this.toggleNavbar(false);
      if (this.$route.params.id > 0) {
        this.$router.push({
          name: "lmsNotif",
          params: { id: 0, cid: 0, title: "Тушаал Цахилгаан" }
        });
      } else {
        this.filterModel = e;
        this.init();
      }
    },
    pageChanged(e) {
      this.pager.page = e;
      this.init();
    },
    init(force) {
      if (force) {
        if (this.$route.params.id > 0) {
          //this.bookDetail(this.$route.params.id);
          this.$router.push({
            name: "lmsNotif",
            params: { id: 0, cid: 0, title: "Тушаал Цахилгаан" }
          });
        } else {
          this.filterModel = { task: "", systemFlag: null };
          this.searchKey++;
          this.navbarMode = 1;
          this.toggleNavbar(false);
        }
      }

      if (this.$route.params.m == 0) {
        request({
          api: { method: "POST", url: "TaskCore/GetCoreList" },
          data: {
            skip: 0,
            size: 100,
            ot: 181,
            model: {
              isPublic: true,
              isTender: false,
              locTypeId:
                this.$route.params.cid > 0 ? this.$route.params.cid : null
            }
          },
          store: this.$store
        }).then(res => {
          if (res != false) {
            //console.log('GetCoreList', res);
            this.allCount = res.data.allCount;
            this.nowDate = res.data.nowDate;
            this.tasks = res.data.tasks;
          }
        });
      } else if (this.$route.params.m == 1) {
        //console.log('this.$route.params.m==1');
        request({
          api: { method: "POST", url: "library/BookList" },
          data: {
            page: this.pager.page - 1,
            size: this.pager.size,
            isTender: true,
            task: this.filterModel["task"],
            locTypeId: null
          },
          store: this.$store
        }).then(res => {
          if (res != false) {
            //console.log('GetCoreList', res);
            this.nowDate = res.data.nowDate;
            this.allCount = res.data.allCount;
            this.tasks = res.data.tasks;
          }
        });
      } else if (this.$route.params.m == 2) {
        request({
          api: { method: "POST", url: "TaskCore/GetCoreList" },
          data: {
            skip: 0,
            size: 100,
            ot: 504,
            model: {
              i1: 1,
              secondUserId: this.$store.state.user.userId
            }
          },
          store: this.$store
        }).then(res => {
          if (res != false) {
            this.nowDate = res.data.nowDate;
            this.allCount = res.data.allCount;
            this.tasks = res.data.tasks;
          }
        });
      } else if (this.$route.params.m == 3) {
        request({
          api: { method: "POST", url: "TaskCore/GetCoreList" },
          data: {
            skip: 0,
            size: 100,
            ot: 504,
            model: {
              secondUserId: this.$store.state.user.userId
            }
          },
          store: this.$store
        }).then(res => {
          if (res != false) {
            this.nowDate = res.data.nowDate;
            this.allCount = res.data.allCount;
            this.tasks = res.data.tasks;
          }
        });
      } else if (this.$route.params.m == 4) {
        request({
          api: { method: "POST", url: "TaskCore/GetCoreList" },
          data: {
            skip: 0,
            size: 100,
            ot: 504,
            model: this.filterModel
          },
          store: this.$store
        }).then(res => {
          if (res != false) {
            this.nowDate = res.data.nowDate;
            this.allCount = res.data.allCount;
            this.tasks = res.data.tasks;
          }
        });
      }
    },
    bookDetail(id) {
      this.bkDtl.rdy = false;
      request({
        api: { method: "GET", url: "Task/taskInheritedDetail" },
        params: {
          id: id
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.bkDtl.obj = res.data.task;
          this.bkDtl.rdy = true;
          //console.log(res.data.task);
        }
      });
    },
    downloadBook() {
      window.open(
        this.bkDtl.obj.secondAttachmentUrl +
          "?i=" +
          Math.floor(Math.random() * 100),
        "_blank"
      );
    },
    initSearches() {
      //console.log('srch fired');
      request({
        api: { method: "GET", url: "TaskCore/GetSearchFields" },
        params: {
          objectTypeId: 181
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          let _flds = ["task", "f3", "f1"];
          //console.log(res.data.fields);
          this.searches = res.data.fields
            .filter(x => hasOneOf(_flds, x["field"]))
            .map(e => Object.assign(e, { val: "" }));
          this.searchRdy = true;
        }
      });
    },
    getCategories() {
      request({
        api: { method: "GET", url: "type/getData" },
        params: {
          key: "lrnbk_type"
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.categories = res.data.types;
        }
      });
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
    },
    orderBook(e) {
      request({
        api: { method: "GET", url: "library/HaveOrderForThisBook" },
        params: {
          id: e.id
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          if (res.data.count == 0) {
            //console.log('HaveOrderForThisBook', e, res);
            this.order.coverId = e.defaultAttachmentId;
            this.order.info = res.data.info;
            let _tip = this.$store.state.app.groupSettings.filter(
              x => x.key == "libOrderTip"
            );
            if (
              _tip.length > 0 &&
              _tip[0].value != undefined &&
              _tip[0].value != ""
            ) {
              this.order.tip = _tip[0].value;
            }
            this.order.obj = e;

            this.toggleBodyClass("addClass", "dynamic-locker");
            let _ot = this.$store.state.app.groupDefaultProjects.filter(
              x => x.objectTypeId == 504
            );
            if (_ot.length) {
              request({
                api: { method: "GET", url: "Task/GetInherited" },
                params: {
                  id: 0,
                  objectTypeId: 504,
                  projectId: _ot[0].id
                },
                store: this.$store
              }).then(res => {
                this.toggleBodyClass("removeClass", "dynamic-locker");
                if (res != false) {
                  this.order.task = res.data.task;
                  this.order.task.organizationTaskId = this.order.obj.id;
                  this.order.task.secondUserId = this.$store.state.user.userId;
                  this.order.mdl = true;
                }
              });
            }
          } else {
            Notification.warning({
              message: "Та энэ номыг захиалах хүсэлт илгээсэн байна",
              title: "Мэдэгдэл",
              duration: 30000,
              type: "success",
              position: "top-right",
              offset: 50
            });
          }
        }
      });
    },
    orderBookPost() {
      //console.log(this.order.task.task);
      if (
        this.order.task.task != null &&
        this.order.task.task != "" &&
        this.order.confirm
      ) {
        this.order.loading = true;
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "Task/PostInherited" },
          data: {
            model: this.order.task
          },
          store: this.$store
        }).then(res => {
          this.order.loading = false;
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.order.mdl = false;
            Notification.success({
              message: "Захиалга амжилттай илгээгдлээ",
              title: "Амжилттай",
              duration: 30000,
              type: "success",
              position: "top-right",
              offset: 50
            });
          }
        });
      } else if (this.order.task.task == null || this.order.task.task == "") {
        Notification.warning({
          message: "Хүсэлт бичнэ үү",
          title: "Мэдэгдэл",
          duration: 30000,
          type: "success",
          position: "top-right",
          offset: 50
        });
      } else if (!this.order.confirm) {
        Notification.warning({
          message: "Зөвшөөрөөгүй байна",
          title: "Мэдэгдэл",
          duration: 30000,
          type: "success",
          position: "top-right",
          offset: 50
        });
      }
    },
    cancelOrderConfirm(e) {
      this.overlayObj.processingId = e.id;
      this.overlayObj.busy = true;
    },
    onItemModal(e) {
      //console.log(e)
      this.order.coverId = e.organizationTask.defaultAttachmentId;
      this.order.itemId = e.organizationTaskId;
      this.order.mdl = true;
    },
    overlayPost() {
      this.overlayObj.processing = true;
      let url = "library/DeclineOrder";
      if (this.$route.params.m == 4) {
        url = "library/DeclineOrder";
      }
      request({
        data: {
          id: this.overlayObj.processingId
        },
        api: { url: url, method: "POST" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.overlayObj.busy = false;
          this.overlayObj.processing = false;
          this.tasks = [];
          this.init();
          this.initStat();
        }
      });
    },

    activitiesDeclinePrompt(e) {
      this.overlayObj.processingId = e.id;
      this.overlayObj.busy = true;
    },
    acceptOrder(e) {
      request({
        api: { method: "GET", url: "Task/taskInheritedDetail" },
        params: {
          id: e.id
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.order.task = res.data.task;
          this.order.task.d3 = moment(new Date(), "DD-MM-YYYY")
            .add(3, "days")
            .format("YYYY-MM-DD");
          this.order.mdl = true;
        }
      });
    },
    acceptOrderPost() {
      request({
        data: {
          id: this.order.task.id
        },
        api: { url: "library/AcceptOrder", method: "POST" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.order.mdl = false;
          this.init();
          this.initLibrarianDashboard();
          Notification.info({
            message: res.msg,
            duration: 30000,
            type: "info",
            position: "top-right",
            offset: 50
          });
        }
      });
    },
    giveBackOrder(e) {
      request({
        data: {
          id: e.id
        },
        api: { url: "library/GiveBackTheBook", method: "POST" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.init();
          this.initLibrarianDashboard();
          Notification.info({
            message: res.msg,
            duration: 30000,
            type: "info",
            position: "top-right",
            offset: 50
          });
        }
      });
    },
    displayMinute(min) {
      let rv = "";
      if (min > 60) {
        rv =
          (min / 60).toFixed(0).padStart(2, "0") +
          "ц : " +
          (min % 60).toFixed(0).padStart(2, "0") +
          "мин";
      } else if (min == 60) {
        rv = "1цаг";
      } else {
        rv = "00 : " + (min % 60).toFixed(0).padStart(2, "0") + "мин";
      }

      return rv;
    },
    readEbook(t) {
      //console.log(t);
      // this.order.info='sdf';
      // this.order.attachId=
      // this.order.mdl= true;
      this.bkDtl.rdy = false;
      request({
        api: { method: "GET", url: "Task/taskInheritedDetail" },
        params: {
          id: t.id
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.order.info = res.data.task.taskDesc;
          this.order.attachId = res.data.task.secondAttachmentId;
          this.order.task = res.data.task;
          this.bkDtl.rdy = true;
          this.order.mdl = true;
        }
      });
    },
    isNewBook(t) {
      let rv = false;
      var a = moment(t.createdDate);
      var b = moment(this.nowDate);
      if (b.diff(a, "days") <= 14) {
        rv = true;
      }
      return rv;
    },

    onFileLoaded(e) {
      //console.log('onFileLoaded', e);
      this.fileInf = { obj: e, ready: true };
    },
    onRated(e) {
      this.fileInf.obj.myRate = e.rate;
      this.fileInf.obj.rateAvg = e.avg;
    },

    //# book execution
    executionInit(e) {
      this.$refs.executionList.initById(e);
    },
    showFile(id) {
      //console.log('showFile=> ', id);
      this.fileDialog.id = id;
      this.fileDialog.show = true;
    },
    onReachBottom(e) {
      // var container = this.$el.querySelector("#executions-outer");
      // $("#executions-outer").animate({
      //   scrollTop: e == "bottom" ? container.scrollHeight : 0
      // });
    },

    purchaseBook() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "post", url: "Payment/CreateInvoiceByTaskId" },
        store: this.$store,
        data: {
          id: this.order.task.id,
          taskDesc: this.order.task.task
        }
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log();
          this.$router.push(`/lms/paymentDetail/${res.data.invoiceId}`);
          //res.data.invoiceId
          // this.statObj.data = res.data.stat;
          // this.statObj.rdy = true;
        }
      });
    }
  },
  watch: {
    "$root.$route"(newRoute, oldRoute) {
      if (
        newRoute.params.id > 0 &&
        newRoute.params.cid &&
        newRoute.params.cid > 0 &&
        newRoute.params.m == 0
      ) {
        this.$nextTick(() => {
          this.bookDetail(newRoute.params.cid);
        });
      }
      if (newRoute.params.cid != oldRoute.params.cid) {
        this.$nextTick(() => {
          this.init();
        });
      }
      if (newRoute.params.m != oldRoute.params.m) {
        this.tasks = [];
        this.init();
        this.build();
      }
    }
  }
};
</script>

<style lang="scss">
@media only screen and (min-width: 1440px) {
  .books {
    .col-xl-3 {
      max-width: 20% !important;
    }
  }
}
@media only screen and (max-width: 575px) {
  .books {
    .col-xs-6 {
      max-width: 50% !important;
    }
  }
}
@media only screen and (max-width: 400px) {
  .books {
    .col-xs-6 {
      max-width: 100% !important;
    }
  }
}
</style>
